export default "__VITE_ASSET__DDVqzE8q__"